import * as React from "react";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { SelectFromModalButton } from "src/components/SelectFromModalButton";
import { loadRoles } from "src/pages/management/usersAndRoles/roles";
import { ZRole, ZSidLabel } from "src/types";

import { SelectRoleModal } from "./SelectRoleModal";

type PropsSelectRole = {
  disabled?: boolean;
  multiple?: boolean;
  value?: ZSidLabel | ZSidLabel[]; // зависит от multiple
  onChange?(newValue?: ZSidLabel | ZSidLabel[]): void;
};

export const SelectRole: React.FC<PropsSelectRole> = (props) => {
  const { disabled, multiple, value, onChange } = props;
  let options: ZSidLabel[] = [];
  if (value) {
    options = Array.isArray(value) ? value : [value];
  }
  const onChangeLocal = (newValue: ZSidLabel[] | null) => {
    if (multiple) {
      onChange?.(newValue ?? []);
    } else {
      onChange?.(newValue?.[0] ?? undefined);
    }
  };
  const [tableStore, setTableStore] = React.useState<
    RtStore<ZRole, {}> | undefined
  >();

  const createStore = () => {
    const st = new RtStore({
      rowKey: "id",
      loader: loadRoles(),
      selectionType: multiple ? "checkbox" : "radio",
      keepSelected: true,
    });
    st.setSelectedKeys(options.map(({ id }) => id));
    setTableStore(st);
  };
  return (
    <SelectFromModalButton
      disabled={disabled}
      options={options}
      multi={multiple}
      onChange={onChangeLocal}
      onOpen={createStore}
    >
      <SelectRoleModal
        tableStore={tableStore}
        srcSelected={options}
        close={() => setTableStore(undefined)}
        onApply={onChangeLocal}
      />
    </SelectFromModalButton>
  );
};
